<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/product" />
          <div class="newsWrapcontent">
            <div class="newsWrap">
              <div class="newslist01">
                <dl class="clearfix" v-for="item in data" :key="item.src">
                  <dt>
                    <a v-if="item.image" :href="item.src"><img :src="baseApi + item.image" /> </a>
                    <div >无图片</div>
                  </dt>
                  <dd>
                    <h3><a :href="item.src">{{item.title}}</a></h3>
                    <p class="time">{{item.date}}</p>
                    <p class="Description">
                      <a :href="item.src">{{item.content}}</a>
                    </p>
                    <p class="more"><a target="_blank" :href="item.src">查看详情</a></p>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/news/componets/Banner'
import Tab from '@/views/news/componets/Tab'
import axios from 'axios'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/',
      data: []
    }
  },
  mounted () {
    axios({
      method: 'get',
      url: process.env.API_ROOT + 'static/news.json'
    })
      .then(response => {
        this.data = response.data.filter(m => m.type === 2)
      }).catch(reason => {
        console.log(reason)
      })
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/news/product.vue